import React, { useContext, useEffect, useState } from 'react';
import { SocketContext } from '../../../SocketProvider';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from '@jobber/components/Button';
import io from 'socket.io-client';
import { postToServer } from '../../../components/Common/requests';
import { showToast } from '@jobber/components/Toast';
import ProgressBar from 'react-bootstrap/ProgressBar';
import DateRangeModal from '../../../components/Common/DateRangeModal';
import { useLocation } from 'react-router';
import { setStartSyncR } from '../../../store/layoutSlice';
import { usePermission } from '../../../hooks/use-permission';
import { SYNC_PERMISSION } from '../../../config/permissions';
import { useJobberSync } from '../../../hooks/use-jobber-sync';

function LoadData({ reload }) {
	const dispatch = useDispatch();
	const { socket, socketHandler } = useContext(SocketContext);
	const [comingMsg, setComingMsg] = useState(null);
	const [progressValue, setProgressValue] = useState(1);
	const [dateModal, setDateModal] = useState(false);
	const { allowed: canStartSync } = usePermission(SYNC_PERMISSION);

	const userStore = useSelector((store) => store.user);
	const user = userStore?.user?.data;
	const { job: durableSyncJob, isActive: hasActiveJob, progress: durableProgress, trackJob } = useJobberSync('visits');

	useEffect(() => {
		if (hasActiveJob) {
			setLoading(true);
			setProgressValue(durableProgress);
		} else if (durableSyncJob?.status === 'completed') {
			setLoading(false);
			setProgressValue(100);
			reload();
		} else if (durableSyncJob && ['failed', 'cancelled'].includes(durableSyncJob.status)) {
			setLoading(false);
		}
	}, [durableSyncJob?.id, durableSyncJob?.status, durableProgress, hasActiveJob]);

	// for header button sync
	const location = useLocation();
	useEffect(() => {
		if (location?.state?.sync && canStartSync) {
			setDateModal(true);
			window.history.replaceState({}, '');
		}
	}, [location, canStartSync]);
	// for header button sync  end

	useEffect(() => {
		if (comingMsg) {
			setProgressValue(comingMsg?.progress);
		}
	}, [comingMsg]);

	useEffect(() => {
		if (!socket) {
			const newSocket = io(process.env.REACT_APP_API_URL);
			console.log(newSocket);
			socketHandler(newSocket);
		}

		if (socket) {
			socket.on(`Genie_Visit_progress_${user?._id}`, (notify) => {
				setComingMsg(notify);
			});
		}
	}, [socket]);

	const joinRoom = async () => {
		if (socket && user?._id) {
			await socket.emit('joinGenieRoom', { userId: user?._id });
		}
	};

	useEffect(() => {
		joinRoom();
	}, [user?._id, socket]);

	const [loading, setLoading] = useState(false);

	const syncVisitHandler = async (startDate, endDate) => {
		setDateModal(false);
		setLoading(true);
		dispatch(setStartSyncR(true));
		showToast({
			message: 'Please wait while we are syncing all visits.',
			variation: 'info'
		});
		const result = await postToServer('sync-visits', { startDate, endDate });
		if (result.status) {
			trackJob(result.syncJob);
			showToast({
				message: result.deduplicated ? 'This sync is already running' : 'Sync queued'
			});
		} else {
			showToast({
				message: result.message || result.error,
				variation: 'error'
			});
		}
		if (!result.status) {
			setLoading(false);
			setProgressValue(1);
		}
	};

	return (
		<div className="">
			<DateRangeModal open={dateModal} onConfirm={syncVisitHandler} onCancel={() => setDateModal(false)} />
			{loading ? (
				<div className="mb-2">
					<ProgressBar animated variant="success" label={`${progressValue}%`} now={progressValue} />
					<p style={{ color: 'red', fontSize: '12px', textAlign: 'center' }} className="mt-1">
						Do not perform any operation, while we are syncing
					</p>
				</div>
			) : (
				canStartSync ? (
					<Button label={'Sync'} onClick={() => setDateModal(true)} />
				) : null
			)}
		</div>
	);
}

export default LoadData;
